import { COMMENT_VIEW, TASKS_VIEW, LAYER_CHANGES_VIEW } from 'components/DocRightRail/Constants'
import { useMemo } from 'react'
import { DocStore } from 'stores/DocStore'

export const useTabSelection = (docStore: DocStore) => {
  const selectedTab = useMemo(() => {
    switch (docStore.rightRailStore.activeTab) {
      case COMMENT_VIEW:
      case TASKS_VIEW:
      case LAYER_CHANGES_VIEW:
        return COMMENT_VIEW
      default:
        return docStore.rightRailStore.activeTab
    }
  }, [docStore.rightRailStore.activeTab])

  return {
    selectedTab,
  }
}
